/**
 * @vuepress
 * ---
 * title: Advance Report
 * @class MinialSinisterTransformer
 * @author José Luis R. <jose.ruiz@jbge.com.mx>
 */

import Transformer from '../transformer'

class MinimalBudget extends Transformer {
  static fetch({
    price
  }) {
    return {
      price
    }
  }
}

export default MinimalBudget
